/* =============================================================
   WOODWALEY — Product Page JS  (ww-product.js)
   ============================================================= */

(function () {
  'use strict';
  // Dedup: only run once even if script is loaded by multiple sections
  if (window.__wwInit) return;
  window.__wwInit = true;


  /* ── 1. STICKY ATC BAR ─────────────────────────────────── */
  function initStickyAtc() {
    if (window.__stickyAtcInit) return; // snippet inline script already handled it
    const bar     = document.querySelector('.ww-sticky-atc');
    const trigger = document.querySelector('.ww-buy-buttons-anchor'); // sentinel div above buy buttons
    if (!bar || !trigger) return;

    // ── Desktop: sit just below the sticky header (reads actual height) ──
    function applyHeaderOffset() {
      if (window.innerWidth < 750) return;
      const header =
        document.querySelector('sticky-header') ||
        document.querySelector('.shopify-section-group-header-group') ||
        document.querySelector('[id*="shopify-section"][id*="header"]') ||
        document.querySelector('header');
      bar.style.top = (header ? header.offsetHeight : 70) + 'px';
    }
    applyHeaderOffset();
    window.addEventListener('resize', applyHeaderOffset);

    // ── IntersectionObserver — works on desktop + iOS Safari ─────────────
    // Fires once immediately with the current state, then on every change.
    //   show = true  → anchor is fully above viewport (buy buttons scrolled off)
    //   show = false → any part of anchor is visible  (buy buttons still on screen)
    // threshold: 0 means "trigger the moment the last pixel of anchor leaves view"
    // Recalculate every rAF — never cache triggerY.
    // Caching fails when images load after script runs and push content down.
    // getBoundingClientRect().top is negative ONLY when element is above
    // the viewport top — never fires for below-fold elements on page load.
    let _lastShow = null;
    function checkVisibility() {
      const show = trigger.getBoundingClientRect().top < 0;
      if (show !== _lastShow) {
        _lastShow = show;
        bar.classList.toggle('ww-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      requestAnimationFrame(checkVisibility);
    }
    requestAnimationFrame(checkVisibility);

    // ── Wire sticky ATC button → main ATC form ───────────────────────────
    const stickyBtn = bar.querySelector('.ww-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainForm = document.querySelector('[data-type="add-to-cart-form"]')
          || document.querySelector('form[action="/cart/add"]');
        if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
      });
    }
  }

  /* ── 2. PREPAID PRICE TOGGLE ───────────────────────────── */
  function initPrepaidPrice() {
    const block = document.querySelector('.ww-price-block');
    if (!block) return;

    const options     = block.querySelectorAll('.ww-price-option');
    const savingsPill = block.querySelector('.ww-savings-pill');
    const discountCode = block.dataset.discountCode || 'PREPAID100';

    // Update sticky bar price on toggle
    function updateStickyPrice(prepaid) {
      const stickyPrice = document.querySelector('.ww-sticky-atc__price');
      const stickyOld   = document.querySelector('.ww-sticky-atc__old');
      const prepaidPrice = block.dataset.prepaidPrice;
      const origPrice    = block.dataset.origPrice;
      if (!stickyPrice) return;
      if (prepaid && prepaidPrice) {
        stickyPrice.textContent = prepaidPrice;
        if (stickyOld && origPrice) { stickyOld.textContent = origPrice; stickyOld.style.display = 'inline'; }
      } else {
        if (origPrice) stickyPrice.textContent = origPrice;
        if (stickyOld) stickyOld.style.display = 'none';
      }
    }

    options.forEach(opt => {
      opt.addEventListener('change', () => {
        const isPrepaid = opt.querySelector('input').value === 'prepaid';
        options.forEach(o => o.classList.toggle('ww-selected', o === opt));
        if (savingsPill) savingsPill.style.display = isPrepaid ? 'flex' : 'none';
        updateStickyPrice(isPrepaid);
        updateBuyNowUrl(isPrepaid, discountCode);
      });
    });
  }


  /* ── 3. BUY NOW BUTTON ─────────────────────────────────── */
  function initBuyNow() {
    const btn = document.querySelector('.ww-buy-now-btn');
    if (!btn) return;

    // bfcache: when user hits Back from checkout, browser restores the page
    // without re-running JS. Button stays disabled. pageshow fires on restore.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) { btn.disabled = false; btn.style.opacity = ''; }
    });

    btn.addEventListener('click', async () => {
      // Prevent double-clicks
      if (btn.disabled) return;
      btn.disabled = true;
      btn.style.opacity = '0.7';

      const variantInput = document.querySelector('[name="id"]');
      const variantId = variantInput ? variantInput.value : btn.dataset.variantId;
      const qtyInput  = document.querySelector('[name="quantity"]');
      const qty       = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      if (!variantId) {
        btn.disabled = false;
        btn.style.opacity = '';
        return;
      }

      // Build line item properties for personalisation
      const properties = {};
      const nameInput = document.querySelector('.ww-pers-name-input');
      const fontInput = document.querySelector('.ww-font-select');
      if (nameInput && nameInput.value.trim()) {
        properties['Personalisation'] = nameInput.value.trim();
      }
      if (fontInput && fontInput.value.trim()) {
        properties['Font'] = fontInput.value.trim();
      }

      try {
        // Add item to cart via AJAX
        const body = { id: parseInt(variantId, 10), quantity: qty };
        if (Object.keys(properties).length) body.properties = properties;

        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body),
        });

        if (!resp.ok) {
          throw new Error('Cart add failed: ' + resp.status);
        }

        // Determine discount code
        const isPrepaid = document.querySelector('.ww-price-option input[value="prepaid"]:checked');
        const discountCode = document.querySelector('.ww-price-block')?.dataset.discountCode;

        if (isPrepaid && discountCode) {
          // Prepaid: GET /checkout?discount=CODE (Releaseit ignores GET navigations)
          window.location.href = '/checkout?discount=' + encodeURIComponent(discountCode);
        } else {
          // COD: reset cart (no stale discount) then navigate to checkout via GET.
          // GET bypasses Releaseit's product-page form-POST listener.
          // Releaseit will handle partial payment at the checkout page when COD is chosen.
          await resetCart();
          window.location.href = '/checkout';
        }

      } catch (err) {
        console.error('[WW Buy Now]', err);
        btn.disabled = false;
        btn.style.opacity = '';
      }
    });
  }

  function updateBuyNowUrl(isPrepaid, discountCode) {
    // Called on price toggle — no URL to pre-build, just flags state
    const btn = document.querySelector('.ww-buy-now-btn');
    if (btn) btn.dataset.prepaid = isPrepaid ? '1' : '0';
  }

  /* ── 5. ADD TO CART — write prepaid code to sessionStorage ─ */

  // Clears the cart cookie and re-adds all items so Shopify creates a
  // brand-new cart with no checkout session → no stale prepaid discount.
  async function resetCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const items = cart.items.map(i => {
        const item = { id: i.variant_id, quantity: i.quantity };
        if (i.properties && Object.keys(i.properties).length) item.properties = i.properties;
        return item;
      });
      const past = 'expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = `cart=; ${past}`;
      document.cookie = `cart=; ${past}; domain=.${location.hostname}`;
      if (items.length) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
      }
    } catch (err) {
      console.error('[WW Reset Cart]', err);
    }
  }

  // Used by cart PAGE and cart DRAWER checkouts.
  // Form POST is intentional there — Releaseit handles COD at the checkout page level.
  async function codCheckout() {
    await resetCart();
    const f = document.createElement('form');
    f.method = 'post'; f.action = '/cart';
    const inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = 'checkout'; inp.value = '1';
    f.appendChild(inp); document.body.appendChild(f); f.submit();
  }

  // On ATC submit: write/clear the prepaid code.
  // Drawer checkout uses event delegation on <cart-drawer> (stable ancestor)
  // so it survives Dawn's AJAX re-render of .cart-drawer__footer.
  // Cart PAGE checkout is handled by main-cart-footer.liquid.
  function initCartAttribute() {
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', () => {
        const isPrepaid = document.querySelector('.ww-price-option input[value="prepaid"]:checked');
        const block = document.querySelector('.ww-price-block');
        const discountCode  = block?.dataset.discountCode;
        const discountPaise = block?.dataset.discountPaise;
        if (isPrepaid && discountCode) {
          sessionStorage.setItem('ww_prepaid_code', discountCode);
          if (discountPaise) sessionStorage.setItem('ww_prepaid_paise', discountPaise);
        } else {
          sessionStorage.removeItem('ww_prepaid_code');
          sessionStorage.removeItem('ww_prepaid_paise');
        }
      });
    });

    // Delegate to <cart-drawer> — never replaced by Dawn, survives all AJAX updates.
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.addEventListener('click', e => {
        if (!e.target.closest('#CartDrawer-Checkout')) return;
        e.preventDefault();
        const code = sessionStorage.getItem('ww_prepaid_code');
        if (code) {
          sessionStorage.removeItem('ww_prepaid_code');
          sessionStorage.removeItem('ww_prepaid_paise');
          window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
        } else {
          codCheckout(); // COD — fresh cart, no stale discount
        }
      });
    }
  }

  /* ── 6. UGC CAROUSEL — auto-scroll ────────────────────── */
  function initUgcCarousel() {
    const scroll = document.querySelector('.ww-ugc-scroll');
    if (!scroll) return;

    let paused = false;
    scroll.addEventListener('mouseenter', () => paused = true);
    scroll.addEventListener('mouseleave', () => paused = false);
    scroll.addEventListener('touchstart', () => paused = true,  { passive: true });
    scroll.addEventListener('touchend',   () => setTimeout(() => paused = false, 2000), { passive: true });

    setInterval(() => {
      if (paused) return;
      const maxScroll = scroll.scrollWidth - scroll.clientWidth;
      if (scroll.scrollLeft >= maxScroll - 10) {
        scroll.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scroll.scrollBy({ left: 260, behavior: 'smooth' });
      }
    }, 3200);

    // Arrow buttons
    document.querySelectorAll('.ww-ugc-arrow').forEach(btn => {
      btn.addEventListener('click', () => {
        const dir = btn.classList.contains('ww-ugc-prev') ? -1 : 1;
        scroll.scrollBy({ left: dir * 260, behavior: 'smooth' });
      });
    });
  }

  /* ── 7. SCROLL-TRIGGERED ANIMATIONS ────────────────────── */
  function initScrollAnimations() {
    if (!window.IntersectionObserver) {
      // No IO support — make everything visible immediately
      document.querySelectorAll('.ww-anim-ready, .ww-anim-left').forEach(el => el.classList.add('ww-anim-in'));
      return;
    }

    // Generic fade-up elements
    const fadeObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('ww-anim-in');
          fadeObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.18 });

    document.querySelectorAll('.ww-anim-ready, .ww-anim-left').forEach(el => fadeObs.observe(el));

    // Statement banner — trigger child elements
    const stmtObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.ww-anim-ready, .ww-anim-left').forEach(c => c.classList.add('ww-anim-in'));
          stmtObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.ww-emo-statement').forEach(el => stmtObs.observe(el));

    // Feature cards — staggered
    const cardObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.ww-emo-card').forEach((c, i) => {
            setTimeout(() => c.classList.add('ww-anim-in'), i * 90);
          });
          cardObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.ww-emo-features-wrap').forEach(el => cardObs.observe(el));

    // Occasion cards — staggered slide-in
    const occObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.ww-occ-card').forEach((c, i) => {
            setTimeout(() => c.classList.add('ww-anim-in'), i * 120);
          });
          occObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.ww-emo-occ-grid').forEach(el => occObs.observe(el));
  }

  /* ── 8. MOBILE: feature card tap toggle ────────────────── */
  function initFeatureCardTap() {
    document.querySelectorAll('.ww-emo-card').forEach(card => {
      card.addEventListener('click', () => {
        const isOpen = card.classList.contains('ww-open');
        document.querySelectorAll('.ww-emo-card.ww-open').forEach(c => c.classList.remove('ww-open'));
        if (!isOpen) card.classList.add('ww-open');
      });
    });
  }

  /* ── 9. VARIANT CHANGE — update prepaid price display ──── */
  function initVariantWatch() {
    const block = document.querySelector('.ww-price-block');
    if (!block) return;

    const discountPaise = parseInt(block.dataset.discountPaise || '10000', 10);

    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;
      const prepaidPaise = variant.price - discountPaise;
      const prepaidFormatted = formatMoney(prepaidPaise);
      const el = block.querySelector('.ww-price-option__current');
      if (el && prepaidFormatted) el.textContent = prepaidFormatted;
    });
  }

  function formatMoney(paise) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(paise, '₹{{amount_no_decimals}}');
    }
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  /* ── INIT ───────────────────────────────────────────────── */
  function init() {
    initStickyAtc();
    initPrepaidPrice();
    initBuyNow();
    initCartAttribute();
    initUgcCarousel();
    initScrollAnimations();
    initFeatureCardTap();
    initVariantWatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
